<template>
  <div class="diagnoses">
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div class="headerPage">
      <div class="container-fluid">
        <div class="row col-12">
          <div class="col-10 d-flex contentHeader" v-if="!id">
            <div class="inputGroup col-lg-7">
              <span>Selecione uma máquina:</span>
              <multiselect
              v-model="selectedMachine"
              :options="machines.map(m => m.id)"
              :custom-label="id => {
                const machine = machines.find(m => m.id === id);
                return machine ? machine.name : '';
              }"
              placeholder="Selecione uma máquina"
              :searchable="true"
              :allow-empty="true"
              :clear-on-select="false"
              :close-on-select="true"
            />
            </div>
            <div class="d-flex contentHeader" v-if="!id">
              <small>{{machines.length}} máquinas cadastradas</small>
            </div>
          </div>
          <button
            class="btn btn-secondary float-right col-2"
            v-on:click="createDiagnones()"
            v-if="!id"
          >Criar Documento</button>
          <div class="col-12 d-flex float-right contentHeaderRight" v-if="id">
            <!-- <div class="icon">
              <font-awesome-icon icon="print" />
            </div>-->
            <b-dropdown text="Exportar" class="m-md-2">
              <b-dropdown-item :href="getExportUrl('xlsx')" target="_blank">Excel</b-dropdown-item>
              <!-- <b-dropdown-item :href="getExportUrl('csv')" target="_blank">CSV</b-dropdown-item>
              <b-dropdown-item :href="getExportUrl('ods')" target="_blank">ODS</b-dropdown-item> -->
              <!-- <b-dropdown-item>CSV</b-dropdown-item> -->
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid" v-if="id">
      <div class="row">
        <div class="col-12 navBarSection">
          <div
            class="navBarItem"
            v-bind:class="{'active': isSelectedSection('diagnoses')}"
            v-on:click="selectSection('diagnoses')"
          >
            <font-awesome-icon icon="suitcase" />
            <span>RISCOS</span>
          </div>

          <!-- <div
            class="navBarItem"
            v-bind:class="{'active': isSelectedSection('anexos')}"
            v-on:click="selectSection('anexos')"
            v-if="id"
          >
            <font-awesome-icon icon="paperclip" />
            <span>ANEXOS</span>
          </div>-->
        </div>
      </div>
    </div>
    <br />

    <!-- <div class="row attachments" v-if="isSelectedSection('anexos')">
      <div class="col-8" v-if="company_id && id">
        <AttachmentsList :company_id="company_id" typeDocument="diagnosis" :document_id="id"></AttachmentsList>
      </div>
    </div>-->

    <div v-if="isSelectedSection('diagnoses') && id">
      <div v-for="diagnoses in diagnosesData" v-bind:key="diagnoses.id" class="col-12">
        <Accordion>
          <template v-slot:title>
            <h5>
              <strong>{{diagnoses.code}}</strong>
              {{diagnoses.description}}
            </h5>
          </template>
          <template v-slot:body>
            <div
              v-for="node_level_1 in diagnoses.nodes_level_1"
              v-bind:key="node_level_1.id"
              class="col-12"
            >
              <Accordion>
                <template v-slot:title v-if="node_level_1.nodes_level_2.length > 0">
                  <strong>{{node_level_1.code}}</strong>
                  {{node_level_1.description}}
                </template>
                <template v-slot:title v-else>{{node_level_1.code}}</template>
                <template v-slot:body v-if="node_level_1.nodes_level_2.length > 0">
                  <div
                    v-for="node_level_2 in node_level_1.nodes_level_2"
                    v-bind:key="node_level_2.id"
                    class="col-12"
                  >
                    <Accordion>
                      <template v-slot:title>
                        <strong>{{node_level_2.code}}</strong>
                      </template>
                      <template v-slot:body>
                        <textarea
                          rows="5"
                          class="form-control"
                          v-model="node_level_2.description"
                          disabled
                        ></textarea>
                        <br />
                        <div style="display: flex;justify-content: flex-end;align-items: self-end;">
                          <label class="mr-2">
                            <strong>Auditoria:</strong>
                          </label>
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="radio"
                              :name="'inlineRadioOptions'+node_level_2.id"
                              id="inlineRadio1"
                              value="ok"
                              v-model="node_level_2.answer"
                              v-on:change="setAnswer(node_level_2)"
                            />
                            <label class="form-check-label" for="inlineRadio1">Ok</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="radio"
                              :name="'inlineRadioOptions'+node_level_2.id"
                              id="inlineRadio"
                              value="not-ok"
                              v-model="node_level_2.answer"
                              v-on:change="setAnswer(node_level_2)"
                            />
                            <label class="form-check-label" for="inlineRadio1">Não Ok</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input
                              class="form-check-input"
                              type="radio"
                              :name="'inlineRadioOptions'+node_level_2.id"
                              id="inlineRadio1"
                              value="dont-apply"
                              v-model="node_level_2.answer"
                              v-on:change="setAnswer(node_level_2)"
                            />
                            <label class="form-check-label" for="inlineRadio1">Não se aplica</label>
                          </div>
                        </div>
                      </template>
                    </Accordion>
                  </div>
                </template>
                <template v-slot:body v-else>
                  <textarea
                    rows="5"
                    class="form-control"
                    v-model="node_level_1.description"
                    disabled
                  ></textarea>
                  <br />
                  <div style="display: flex;justify-content: flex-end;align-items: self-end;">
                    <label class="mr-2">
                      <strong>Auditoria:</strong>
                    </label>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :name="'inlineRadioOptions'+node_level_1.id"
                        id="inlineRadio1"
                        value="ok"
                        v-model="node_level_1.answer"
                        v-on:change="setAnswer(node_level_1)"
                      />
                      <label class="form-check-label" for="inlineRadio1">Ok</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :name="'inlineRadioOptions'+node_level_1.id"
                        id="inlineRadio1"
                        value="not-ok"
                        v-model="node_level_1.answer"
                        v-on:change="setAnswer(node_level_1)"
                      />
                      <label class="form-check-label" for="inlineRadio1">Não Ok</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :name="'inlineRadioOptions'+node_level_1.id"
                        id="inlineRadio1"
                        value="dont-apply"
                        v-model="node_level_1.answer"
                        v-on:change="setAnswer(node_level_1)"
                      />
                      <label class="form-check-label" for="inlineRadio1">Não se aplica</label>
                    </div>
                  </div>
                </template>
              </Accordion>
            </div>
          </template>
        </Accordion>
      </div>
      <div class="col-12" style="margin-top: 50px; margin-bottom: 20px">
        <button class="btn btn-success float-right" v-on:click="save()"><span>Salvar <font-awesome-icon icon="save" /> </span></button>
      </div>
      <br />
      <div class="col-12 col-padding" style="margin-top: 30px;">
        <b-alert v-show="alert" :variant="alert_type" show>{{alert_msg}}</b-alert>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Accordion from "@/components/Accordion.vue";
// import AttachmentsList from "@/components/AttachmentsList.vue";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  name: "Diagnoses",
  components: {
    Accordion,
    Multiselect,
    // AttachmentsList
  },
  props: {
    id: String,
    company_id: String,
  },
  watch: {
    company_id(newVal) {
      this.localCompanyId = newVal;
      if (newVal) {
        this.getCompany(newVal);
      }
    },
  },
  data() {
    return {
      localCompanyId: this.company_id || localStorage.getItem('company_id'),
      alert: false,
      alert_type: "success",
      alert_msg: "Diagnóstico salvo",
      diagnosesData: [],
      answers: { diagnosis_id: "", data: [] },
      selectedSection: "diagnoses",
      machines: [],
      diagnosis: {},
      selectedMachine: "",
      items: [
        {
          text: "Documentos",
          href: "#/admin/Documents/Index"
        },
        {
          text: "",
          href: `#/admin/Documents/Company/${this.company_id || localStorage.getItem('company_id')}`,
        },
        {
          text: "Diagnósticos",
          href: `#/admin/Documents/ListDocuments/${this.company_id || localStorage.getItem('company_id')}/Diagnoses`,
        },
        {
          text: "Diagnóstico",
          active: true
        }
      ]
    };
  },
  mounted:async function() {
    const loader = this.$loading.show();
    if (this.localCompanyId) {
      this.getCompany(this.localCompanyId);
    }
    if (this.id) {
      await this.getDiagnosesData();
    }else{
      await this.getMachinesByCompanyId();
    }
    loader.hide();
  },
  methods: {
    getCompany: function (company_id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/admin/companies/${company_id}`)
        .then((response) => {
          this.items[1].text = response.data.data.corporate_name;
        });
    },
    getMachinesByCompanyId: async function () {
      const response = await axios.get(
        `${process.env.VUE_APP_API_HOST}/api/admin/machines?company_id=${this.localCompanyId}`,
        {
          params: {
            reduced: true,
            not_paginated: true,
            not_gallery: true,
          },
        }
      );
    this.machines = response.data.data;
    },
    selectSection: function(section) {
      this.selectedSection = section;
    },
    isSelectedSection: function(section) {
      return this.selectedSection == section;
    },
    createDiagnones: async function() {
      await axios
        .post(`${process.env.VUE_APP_API_HOST}/api/admin/diagnoses`, {
          is_finished: false,
          executed_at: moment().format("YYYY-MM-DD"),
          company_id: this.localCompanyId,
          machine_id: this.selectedMachine
        })
        .then(async (response) => {
          this.id = response.data.id;
          await this.createAnswers();
        });
    },
    getDiagnosesData: function() {
      let promise = axios.get(
        `${process.env.VUE_APP_API_HOST}/api/admin/nr-references-diagnoses`
      );
      promise.then((response) => {
        if (this.id) {
          let promise = axios.get(
            `${process.env.VUE_APP_API_HOST}/api/admin/diagnoses/${this.id}?include=answers`
          );
          promise.then(data => {
            this.diagnosis = data.data.data;
            this.answers.data = this.diagnosis.answers;
            this.diagnosesData.forEach(el => {
              el.nodes_level_1.forEach(level_1 => {
                let answer = this.diagnosis.answers.find(
                  answer => answer.nr_reference_id == level_1.id
                );
                level_1.answer = answer ? answer.value : "";
                level_1.nodes_level_2.forEach(level_2 => {
                  let answer = this.diagnosis.answers.find(
                    answer => answer.nr_reference_id == level_2.id
                  );
                  level_2.answer = answer ? answer.value : "";
                });
              });
            });
          });
          this.diagnosesData = response.data;
        }
        // this.diagnosesData = response.data;
      });
    },
    setAnswer(dataAnswer) {
      let index = this.answers.data.findIndex(
        el => el.nr_reference_id == dataAnswer.id
      );
      //deveria inserir o answer id aqui se não for o nr_reference_id esse proprio id
      if (index == -1)
        this.answers.data.push({
          nr_reference_id: dataAnswer.id,
          value: dataAnswer.answer
        });
      else {
        this.answers.data[index].value = dataAnswer.answer;
      }
    },

    createAnswers: async function() {
      let promise = await axios.get(
        `${process.env.VUE_APP_API_HOST}/api/admin/nr-references-diagnoses`
      );
      promise.then(async (response) => {
        this.diagnosesData = response.data;
        this.diagnosesData.forEach(el => {
          el.answer = '';
          this.setAnswer(el);
          el.nodes_level_1.forEach(level_1 => {
            if (level_1.nodes_level_2.length == 0) {
              level_1.answer = "dont-apply";
            }
            else{
              level_1.answer = "";
            }
            this.setAnswer(level_1);
            level_1.nodes_level_2.forEach(level_2 => {
              if (level_2.nodes_level_3.length == 0) {
                level_2.answer = "dont-apply";
              }
              else{
                level_2.answer = "";
              }
               this.setAnswer(level_2);
            });
          });
        });
        this.answers.diagnosis_id = this.id;
        let promise2 = await axios.post(
          `${process.env.VUE_APP_API_HOST}/api/admin/answers`,
          {
            answers: this.answers
          }
        );
        promise2
          .then(response => {
            this.answers = response.data;
          })
          .catch(() => {
            this.alert_type = "warning";
            this.alert_msg = "Ocorreu um erro";
            this.alert = true;
            const vm = this;
            setTimeout(() => {
              vm.alert = false;
            }, 3000);
          });

        // this.diagnosesData = response.data;
      });
    },
    save: async function() {
      var promise = null;
      promise = await axios.put(
        `${process.env.VUE_APP_API_HOST}/api/admin/diagnoses`,
        {
          is_finished: false,
          executed_at: moment().format("YYYY-MM-DD"),
          company_id: this.company_id,
          diagnosis_id: this.id,
          user_id: localStorage.getItem("auth.user_id") // adicionei esse user para o doc changes
        }
      );

      promise.then(async (response) => {
        //coloquei esse if por que essa reponse não retornava id nenhum se fosse um update
        //pega o id que vem da tela e manda para o diagnosis
        //mudar na controller para "$answers['diagnosis_id']" onde ele recebe diagnosis_id (update)
        if (this.id) {
          this.answers.diagnosis_id = this.id;
        } else {
          this.id = response.data.id;
          this.answers.diagnosis_id = this.id ? this.id : response.data.id;
        }
        let promise2 = await axios.put(
          `${process.env.VUE_APP_API_HOST}/api/admin/answers`,
          {
            answers: this.answers
          }
        );
        promise2
          .then(() => {
            localStorage.setItem('diagnoses_success_notification', 'true');
            
            setTimeout(() => {
              this.alert = false;
              this.$router.push({
                name: 'ListDocuments',
                params: {
                  company_id: this.localCompanyId,
                  doctype: 'Diagnoses',
                  docTypeText: 'Diagnósticos'
                }
              });
              //redirect
            }, 1500);
          })
          .catch(() => {
            this.alert_type = "warning";
            this.alert_msg = "Ocorreu um erro";
            this.alert = true;
            const vm = this;
            setTimeout(() => {
              vm.alert = false;
            }, 3000);
          });
      });
    },
    getExportUrl: function(ext) {
      return `${process.env.VUE_APP_API_HOST}/export-diagnosis/${this.id}.${ext}`;
    }
  }
};
</script>
<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap";
@import "node_modules/bootstrap-vue/src/index.scss";
@import "src/styles/General.scss";
@import "src/styles/DVS.scss";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
